<svelte:options tag="edi-svg-search" />

<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		opacity="0.7"
		d="M18.3339 17.0402L13.3595 12.0656C14.4563 10.7859 15.0926 9.13008 15.0926 7.3125C15.0926 3.27305 11.8187 0 7.78049 0C3.7423 0 0.5 3.2741 0.5 7.3125C0.5 11.3509 3.77359 14.625 7.78049 14.625C9.59727 14.625 11.2555 13.9584 12.5334 12.8619L17.5077 17.8365C17.6483 17.9438 17.7925 18 17.9366 18C18.0807 18 18.2245 17.9451 18.3342 17.8352C18.5553 17.6168 18.5553 17.2582 18.3339 17.0402ZM7.81213 13.5C4.37051 13.5 1.62495 10.7227 1.62495 7.3125C1.62495 3.90234 4.37051 1.125 7.81213 1.125C11.2537 1.125 13.9993 3.8707 13.9993 7.3125C13.9993 10.7543 11.2221 13.5 7.81213 13.5Z"
		fill="#435765"
	/>
</svg>
